export const PASSWORD_MIN_LENGTH = 8;

export function isPasswordStrong(password) {
  if (!password || password.length < PASSWORD_MIN_LENGTH) {
    return false;
  }

  return (
    /[a-z]/.test(password) &&
    /[A-Z]/.test(password) &&
    /[0-9]/.test(password) &&
    /[^A-Za-z0-9]/.test(password)
  );
}
